import UseIdleTimeout from "../components/layout/AppHeader/useIdleTimeout";
import UseIdleTimeoutEstadoUsuario from "../components/layout/AppHeader/useIdleTimeoutEstadoUsuario";
import { UseAppRouter } from "../useAppRouter";

export const SessionManager = () => {
  const { timeOut, signOut, is_Login, timeOutEstadoUsuario, timeOutModal } =
    UseAppRouter();

  return (
    <>
      <UseIdleTimeout timeout={timeOut} onLogout={signOut} isLogin={is_Login} />
      <UseIdleTimeoutEstadoUsuario
        timeOutEstadoUsuario={timeOutEstadoUsuario}
        timeOutModal={timeOutModal}
        onLogout={signOut}
        isLogin={is_Login}
      />
    </>
  );
};
